module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Da-Eb.e1103181.png";